import type { Opportunity } from '@/api/client'
import { OPPORTUNITY_MEANING } from '@/lib/opportunity'
import { statusOf } from '@/lib/status'
import { TonePill } from './StatusPill'

/** A keyword's opportunity tier as a pill: 최우선 · 틈새 · 치열 · 낮음 · 미측정.
 *  Hovering it says what the tier means. */
export function TierPill({ tier, className }: { tier: Opportunity | string; className?: string }) {
  const def = statusOf('opportunity', tier)
  const meaning = OPPORTUNITY_MEANING[tier as Opportunity]
  return (
    <span title={meaning} className="inline-flex">
      <TonePill tone={def.tone} label={def.label} dim={def.dim} className={className} />
    </span>
  )
}
